import { createRouter, createWebHistory } from 'vue-router'

import IndexRoot from '@/components/IndexRoot.vue'
import LoginPage from '@/components/LoginPage'
import JournalRoot from '@/components/journal/JournalRoot.vue'
import JournalRedirect from '@/components/journal/JournalRedirect.vue'
import ParentPage from '@/components/journal/parent/ParentPage.vue'
import TaxDeductionRequestsPage from '@/components/journal/parent/tax-deduction/TaxDeductionRequestsPage.vue'
import EmployeePage from '@/components/journal/employee/EmployeePage.vue'
import KindergartenDirectorPage from '@/components/journal/kindergarten-director/KindergartenDirectorPage.vue'
import EmployeeJournalPage from '@/components/journal/employee/EmployeeJournalPage.vue'
import RegistrationRequestsPage from '@/components/journal/employee/requests/RegistrationRequestsPage.vue'
import CorrectionRequestsPage from '@/components/journal/employee/requests/CorrectionRequestsPage.vue'
import ChangePasswordPage from '@/components/journal/ChangePasswordPage.vue'
import PayRoot from '@/components/pay/PayRoot.vue'
import PayPage from '@/components/pay/PayPage.vue'
import PayResult from '@/components/pay/PayResult.vue'
import NotFoundPage from '@/components/NotFoundPage.vue'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: IndexRoot
    },
    {
      path: '/login',
      component: LoginPage
    },
    {
      path: '/journal',
      component: JournalRoot,
      children: [
        {
          path: '',
          component: JournalRedirect
        },
        // TODO: add user type checks for each of the sub-pages
        {
          path: 'parent',
          children: [
            {
              path: '',
              component: ParentPage
            },
            {
              path: 'tax-deduction',
              component: TaxDeductionRequestsPage
            }
          ]
        },
        {
          path: 'employee',
          component: EmployeePage,
          children: [
            {
              path: '',
              component: EmployeeJournalPage
            },
            {
              path: 'registration-requests',
              component: RegistrationRequestsPage
            },
            {
              path: 'correction-requests',
              component: CorrectionRequestsPage
            }
          ]
        },
        {
          path: 'kindergarten-director',
          component: KindergartenDirectorPage
        },
        {
          path: 'change-password',
          component: ChangePasswordPage
        }
      ]
    },
    {
      path: '/pay',
      component: PayRoot,
      children: [
        {
          path: '',
          component: PayPage
        },
        {
          path: 'result',
          component: PayResult
        }
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      component: NotFoundPage
    }
  ]
})
